module.exports = __webpack_public_path__ + "img/ic-layouts-active.7b638948.svg";